import clsx from "clsx";
import React, { ReactNode } from "react";
import styled from "styled-components";

const Container = styled.div`
  max-width: 1400px;
`;

type ContentContainerProps = {
  children?: ReactNode;
  className?: string;
};

const ContentContainer: React.FC<ContentContainerProps> = ({ children, className = "" }) => {
  return <Container className={clsx("container", className)}>{children}</Container>;
};

export default ContentContainer;
